import { useEffect, useState } from 'react';
import { setIsMobile as setIsMobileAction } from '../app/slice/appSlice';
import { useAppDispatch } from '../app/hooks';

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
      dispatch(setIsMobileAction(window.innerWidth < breakpoint));
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [breakpoint, dispatch]);

  return isMobile;
};

export default useIsMobile;
